import { FC } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';

import { useActions } from '../../hooks/useActions';

import AuthActions from './AuthActions/AuthActions';
import AuthBottom from './AuthWrapper/AuthBottom/AuthBottom';
import AuthHeader from './AuthWrapper/AuthHeader/AuthHeader';
import { IAuthFormInput, TypeForm } from './auth.interface';
import AuthFields from './forms/AuthFields';
import { useAuthForm } from './useAuthForm';

interface IAuthForm {
  type: TypeForm;
}

const Auth: FC<IAuthForm> = ({ type }) => {
  const { login } = useActions();

  const { onRegisterEmail, onRegisterPhone, phone_or_email } = useAuthForm();
  const form = useForm<IAuthFormInput>({
    mode: 'onChange',
  });

  const onSubmit: SubmitHandler<IAuthFormInput> = async (data, e) => {
    switch (type) {
      case 'email':
        onRegisterEmail(data.email);
        break;
      case 'phone':
        onRegisterPhone(data.phone);
        break;
      case 'code':
        login({
          phone_or_email,
          password: form.getValues().code,
          is_one_time_password: true,
        });
        break;
      default:
        return;
    }
  };
  return (
    <FormProvider {...form}>
      <AuthHeader type={type} />
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <AuthFields
          type={type}
          formState={form.formState}
          register={form.register}
        />
        <AuthActions type={type} />
      </form>
      <AuthBottom type={type} />
    </FormProvider>
  );
};

export default Auth;
